import axios from "axios";

export const FileTypes = {
    CSS: 'css'
}

export const addStyles = (files: Array<string>, parent: HTMLHeadElement) => {
    // Create array of HTMLLinkElement elements
    const styleElements: Array<HTMLLinkElement> = files.map((filePath: string) => {
        return createStyleElement(filePath);
    });
    // Recursively add each element to parent after the previous element was loaded 
    function recursivelyAddElement(styleElements: Array<HTMLLinkElement>) {
        if(Boolean(styleElements.length)) {
            let styleElementToAdd = styleElements[0];
            let remainingStyleElements = styleElements.slice(1);
            styleElementToAdd.onload = function() {
                recursivelyAddElement(remainingStyleElements);
            }
            parent.appendChild(styleElementToAdd);
        }
    }
    recursivelyAddElement(styleElements);
};

export const injectAsset = (type: string, filename: string, baseUrl?: any ) => {
    
    const scriptElement = getScriptTagElement()
    let assetUrl: string
    
    if( baseUrl && typeof baseUrl === 'string' ) {
        assetUrl = baseUrl + filename
    } else {
        console.warn('try to inject assets without base url')
        // create the asset url based on the script source and filename
        assetUrl = createAssetUrl(scriptElement.src, filename)
    }

    // inject the asset based on the type
    switch( type ) {
        case FileTypes.CSS: 
            injectCSS( createStyleElement(assetUrl), scriptElement )
            break;
        default: 
            
    }
}

const getScriptTagElement = () => {
    // get all script element and parse it to an array
    const scriptElements = [].slice.call(document.getElementsByTagName('script'))

    // find the correct script element
    const scriptElement = scriptElements
        // .map((scriptElement: any) => scriptElement.src)
        .find((scriptElement: any) => scriptElement.src.indexOf('_vtifrontend/main.js') !== -1)

    // if no script element was found the last one is returned
    return scriptElement ? scriptElement : scriptElements[scriptElements.length - 1]
}

 // build the url based on the src url and the filename
const createAssetUrl = ( srcUrl: string, assetName: string ) => getAssetBaseUrl( srcUrl ) + assetName

// split the given url and recreates the url without the last split
// e.g. 'http://www.test.de/test/test.test' results to 'http://www.test.de/test/'
const getAssetBaseUrl = ( url: string ) => 
    url.split('/')
        .reduce((accumulator: any, part: any, index: number, arr: any) =>
            index < arr.length - 1 ? accumulator + part + '/' : accumulator, '')

const createStyleElement = (url: string) => {
    // create a link element
    const linkElement = document.createElement('link')

    // setup link element
    linkElement.href = url
    linkElement.rel = 'stylesheet'
    linkElement.type = 'text/css'

    return linkElement
}

async function injectCSS (linkElement: any, scriptElement: any) {
    // // test if injection will fail by making an ajax request
    if (await isFileAvailable(linkElement.href)) {
        // insert the style before the script element of vti main.js
        scriptElement.parentNode.insertBefore(linkElement, scriptElement)
    } else {
        /**
         * Do something else if the test fails
         */
    }
}

const isFileAvailable = ( url: string ) => 
    axios.get( url )
        .then((res:any) => true)
        .catch((err:any)=> false)

const injectJS = () => {
    /**
     * TODO: build a proper javascript injector
     */
}

const injectIMG = () => {
    /**
     * TODO: build a proper image injector
     */
}


export default { injectAsset, FileTypes }